import styled from "styled-components";

export const ModalContent = styled.div`
  background-color: #000fff;
  padding: 0rem 1rem 1rem 1rem;
  text-align: center;
  border: 0px;

  justify-content: center;
  vertical-align: middle;

  p {
    margin-top: 0;
    margin-bottom: 0;

  }
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const Button = styled.div`
  width: 50%;
  height: 40px;
  margin-top: 5px;
  margin-left: 1px;
  background: #00ffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000004d;
  outline: none !important;
  border: 0;
  border-radius: 7px;
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  padding: 1px;
  color: #0068ff;
  font-weight: Bold;
  &:hover {
    filter: brightness(90%);
  }
  span {
    color: #0068ff;
  }
  @media (max-width: 769px) {
    width: 100%;
  }
  @media (min-width: 855px) and (max-width: 975px) {
    font-size: 0.9rem;
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  position:absolute;
  top:-42px;
  left:auto;
  right:-10px;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  color:#ffffff;
  cursor:pointer;
`;

export const Logo = styled.img`
  height: auto;
  width: 70%;
  cursor: "pointer";
`;
